import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled, { useTheme } from 'styled-components';

const StyledH4 = styled.h4`
  font-weight: bold;
  font-size: 22px;
  margin-bottom: 12px;
`;

const SmartTariffInfoContent = () => {
  const theme = useTheme();

  return (
    <>
      <StyledH4>More about smart tariffs</StyledH4>
      <p>
        A <b>smart tariff</b> is a type of energy pricing plan that uses data from a <b>smart meter</b> to charge
        different rates for electricity depending on <b>when and how</b> you use it.
      </p>
      <p>There are two main types of pricing for smart tariffs:</p>
      <p>
        <b>Time-of-use:</b>
      </p>
      <p>
        <ul>
          <li>
            Prices vary at different (but fixed) times of day (e.g. cheaper at night, more expensive during peak hours).
          </li>
          <li>
            Encourages using energy during off-peak times when demand is lower and electricity is cheaper to produce.
          </li>
        </ul>
      </p>
      <p>
        <b>Real-time or dynamic:</b>
      </p>
      <p>
        <ul>
          <li>Some tariffs change prices hourly or daily based on wholesale market rates.</li>
          <li>These are more advanced and may suit people who can adjust their usage accordingly (e.g. EV owners).</li>
        </ul>
      </p>
      <p>The smart tariffs that are compatible with Optimise are typically:</p>
      <p>
        <ul>
          <li>EV tariffs (e.g. Octopus Go, British Gas Electric Driver)</li>
          <li>Agile tariffs (e.g. Octopus Agile)</li>
          <li>Tracker tariffs (e.g. EDF Evolve Tracker, Octopus Tracker)</li>
          <li>Battery tariffs (e.g. Octopus Flux)</li>
          <li>Heat pump tariffs (e.g. Octopus Cosy, EDF Heat Pump Tracker)</li>
        </ul>
      </p>
      <p>
        <FontAwesomeIcon icon={faExclamationTriangle} size={'sm'} color={theme.colors.error} /> Economy 7 and Economy 10
        tariffs are technically time-of-use tariffs, but there’s limited benefit to using them with Optimise so they are
        not supported.{' '}
      </p>
      <p>
        So, <b>if you have a smart import and export tariff</b> or{' '}
        <b>just a smart import and are waiting on an export tariff</b>, select <b>Yes</b> when you return to the main
        screen, and you'll be able to select from the list of supported suppliers and smart tariffs.{' '}
      </p>
    </>
  );
};

export default SmartTariffInfoContent;
